export const GET_POLICY_DETAILS = "GET_POLICY_DETAILS";
export const SAVE_PAYMENT = 'SAVE_PAYMENT';
export const Payload_entry = 'PAYLOAD_ENTRY';
export const SET_UPI_ASBA_FLAG = 'SET_UPI_ASBA_FLAG';
export const GET_POLICY_INVOKE = 'GET_POLICY_INVOKE';
export const SET_USER_TYPE = 'SET_USER_TYPE';
export const SET_TOKEN_MIS = 'SET_TOKEN_MIS';
export const SET_USER_DATA ='SET_USER_DATA'
